import { Form, Input } from "@oxygen/core";
import getThemeClasses from "@oxygen/theme";
import { CSSAbsolute } from "GlobalComponent/CSSCore";
import React, { useState } from "react";
import { getValidationStatus } from "../utils";
import styles from "./scss/FormInputs.module.scss";

export const EmailInput = ({ email, label, handleEmailInput }) => (
  <Form.Item
    validateStatus={getValidationStatus(email.isValid)}
    helperText={email.errMessage}
  >
    <Input
      id="email"
      type="email"
      placeholder="Enter Your Email Id"
      value={email.value}
      label={label}
      onChange={handleEmailInput}
    />
  </Form.Item>
);

const showPasswordButtonClasses = getThemeClasses(`
  font-weight-bold;
  color-blue-light;
  cursor-pointer;
  font-size-6.5;
  bg-white;
`);
const passwordClasses = getThemeClasses(`
  position-relative;
`);
export const PasswordInput = ({
  isShowbutton,
  password,
  label,
  handlePasswordInput,
}) => {
  const [type, setType] = useState("password");

  const handleShowPasswordClick = () => {
    setType(type === "password" ? "text" : "password");
  };

  return (
    <Form.Item
      validateStatus={getValidationStatus(password.isValid)}
      helperText={password.errMessage}
      className={passwordClasses}
    >
      <Input
        id="password"
        placeholder="Enter Your Password"
        maxLength="15"
        type={type}
        label={label}
        value={password.value}
        onChange={handlePasswordInput}
      />
      {isShowbutton && (
        <CSSAbsolute
          as="span"
          className={`${showPasswordButtonClasses} ${styles.showPasswordButton}`}
          onClick={handleShowPasswordClick}
        >
          Show
        </CSSAbsolute>
      )}
    </Form.Item>
  );
};
